import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { useState } from "react"
import type { ISimulatorApplication } from "types/simulatorApplicationTypes"
import { DeleteSimulatorApplicationDialog } from "./DeleteSimulatorApplicationDialog"
import { UpdateSimulatorApplicationDialog } from "./UpdateSimulatorApplicationDialog"

type Props = {
  app: ISimulatorApplication
}

export function SimulatorApplicationCardMenu({ app }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <DeleteSimulatorApplicationDialog app={app} />
        <UpdateSimulatorApplicationDialog app={app} />
      </Menu>
    </>
  )
}
